export default __webpack_public_path__ + "assets/courier-getstarted-phone-2x.png";